// Поля в списке
export const fields = [
    {
      title: 'Заголовок',
      path: 'title',
      width: '30%',
    },
    {
      title: 'Подзаголовок',
      path: 'subtitle',
      width: '30%',
    },
    {
      title: 'Дата изменения',
      path: 'updated_at',
      width: '20%',
    },
    {
      title: 'Активность',
      path: 'is_active',
      width: '20%',
    },
    {
      title: 'В фильтре на сайте',
      path: 'use_in_filter',
      width: '20%',
    },
  ];

export const validData = {
    title: {
        noempty: 'Название обязательно для заполнения'
    },
    sort: {
        isnumber: 'Сортировка должна быть числом'
    }
}
